module.exports = __webpack_public_path__ + "media/images/landing_page/digweddash4_mobile-60f19b95b0709dbdac7b91406262bad2.png";